import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FavoritesListState, favoritesFeatureKey, selectAllFavoritesLists } from './favorites.reducer';

export const selectFavoritesListsState = createFeatureSelector<FavoritesListState>(favoritesFeatureKey);

export const selectFavoritesListsStatus = createSelector(
  selectFavoritesListsState,
  (state) => state.favoritesListsStatus,
);

export const selectFavoritesLists = createSelector(selectFavoritesListsState, (state) =>
  selectAllFavoritesLists(state.favoritesLists),
);

export const selectFavoriteListArticles = createSelector(
  selectFavoritesListsState,
  (state) => state.favoriteListArticles,
);

export const selectFavoriteListArticlesPaginationMetadata = createSelector(
  selectFavoritesListsState,
  (state) => state.favoriteListArticlesPaginationMetadata,
);

export const selectFavoriteListArticlesStatus = createSelector(
  selectFavoritesListsState,
  (state) => state.favoriteListArticlesStatus,
);
